/**
 * fetchAPIを使うFunction群
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as common from "./common";
import * as md from "./mdParse";
/** HTML 属性値のエスケープ */
function escapeAttr(s) {
    return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
export default class FetchOperation {
    /**
     * 渡されたHTML要素の子要素としてINPUT要素を作り、INPUTに変更があった場合にサーバーに送信
     * Bodyまたは指定した要素を書き換える
     */
    sendByInputElem(source, send_url = null, target_id = null) {
        var _a, _b;
        // 渡された要素の値
        const source_value = source.innerText;
        // DB上のレコード一意のID
        const pk = common.getId(source.id);
        // 渡された要素の名前
        const source_name = (_a = source.getAttribute("name")) !== null && _a !== void 0 ? _a : source.dataset.name;
        const token = (_b = source.dataset.token) !== null && _b !== void 0 ? _b : null;
        // クラス名に「type--タイプ名」がある場合はタイプ名を取得
        const typeClass = Array.from(source.classList).find(c => c.startsWith("type--"));
        const inputType = typeClass ? typeClass.substring(6) : "text";
        // 元々の要素中身を削除してINPUTを生成
        source.innerHTML = "";
        source.insertAdjacentHTML("afterbegin", `<input id="${source.id}input" type="${inputType}" name="${source_name}" value="${escapeAttr(source_value)}">`);
        // 生成したInput Element
        const input_elem = document.getElementById(`${source.id}input`);
        if (input_elem) {
            input_elem.focus();
            input_elem.select();
            // 値が変更されたらPOST
            input_elem.addEventListener("change", () => {
                // カンマ区切りの数値からカンマを削除（例: "1,000" → "1000"）
                let inputValue = input_elem.value;
                const numericFields = ['unit_price', 'unit_cost', 'quantity', 'price', 'cost', 'receipt', 'payment'];
                if (source_name && numericFields.includes(source_name)) {
                    inputValue = inputValue.replace(/,/g, '');
                }
                const params = {
                    pk: pk,
                    [source_name !== null && source_name !== void 0 ? source_name : '']: inputValue,
                    _token: token !== null && token !== void 0 ? token : '',
                };
                this.rewriteElems(this.post(params, send_url), target_id);
            });
            // フォーカスを外した場合は元の要素に戻す
            input_elem.addEventListener("blur", () => {
                source.innerHTML = "";
                if (["TD", "P", "DIV"].includes(source.nodeName)) {
                    source.insertAdjacentHTML("afterbegin", escapeAttr(source_value));
                }
                if (source.nodeName === "SUP") {
                    source.insertAdjacentHTML("afterbegin", source.outerHTML);
                }
            });
        }
    }
    /**
     * select要素を引数にOPTIONの値をFetch、レスポンスからDOM書き換え
     */
    sendBySelectElem(source, send_url = null, target_id = null) {
        var _a, _b;
        const name = (_a = source.getAttribute("name")) !== null && _a !== void 0 ? _a : source.id;
        const pk = common.getId(source.id);
        const value = source.options[source.selectedIndex].value;
        const token = (_b = source.dataset.token) !== null && _b !== void 0 ? _b : null;
        const params = {
            pk: pk,
            [name]: value,
            _token: token,
        };
        this.rewriteElems(this.post(params, send_url), target_id);
    }
    /**
     * 取得した要素から、name:data-valueでパラメーターを作り送信
     */
    sendByElem(source, send_url = null, target_id = null) {
        var _a, _b;
        const pk = common.getId(source.id);
        const name = source.getAttribute("name");
        const value = (_a = source.value) !== null && _a !== void 0 ? _a : source.dataset.value;
        const token = (_b = source.dataset.token) !== null && _b !== void 0 ? _b : null;
        if (name) {
            const params = {
                pk: pk,
                [name]: value,
                _token: token,
            };
            this.rewriteElems(this.post(params, send_url), target_id);
        }
    }
    /**
     * チェックボックスの状態を送信
     */
    sendByCheckedElem(source, send_url = null, target_id = null) {
        var _a;
        const name = source.name;
        const checked = source.checked ? 1 : 0;
        const pk = common.getId(source.id);
        const token = (_a = source.dataset.token) !== null && _a !== void 0 ? _a : null;
        const params = {
            pk: pk,
            [name]: checked,
            _token: token,
        };
        this.rewriteElems(this.post(params, send_url), target_id);
    }
    /**
     * Form要素のIDからサーバーへ送信
     */
    sendByFormElem(form_id, send_url = null, target_id = null) {
        var _a;
        const form = document.getElementById(form_id);
        if (!form)
            return;
        const fd = new FormData();
        for (let i = 0; i < form.elements.length; i++) {
            const el = form.elements[i];
            if (el instanceof HTMLInputElement) {
                if (el.type === "file") {
                    for (const file of Array.from((_a = el.files) !== null && _a !== void 0 ? _a : [])) {
                        fd.append("file[]", file);
                    }
                }
                else if (["text", "tel", "email", "hidden", "date", "number"].includes(el.type)) {
                    if (el.name)
                        fd.append(el.name, el.value);
                }
            }
            else if (el instanceof HTMLTextAreaElement) {
                if (el.name)
                    fd.append(el.name, el.value);
            }
            else if (el instanceof HTMLSelectElement) {
                if (el.name)
                    fd.append(el.name, el.value);
            }
        }
        this.rewriteElems(this.send(fd, send_url), target_id);
    }
    /**
     * FormDataを渡してFETCH
     */
    send(fd, send_url) {
        return (() => __awaiter(this, void 0, void 0, function* () {
            const request = new Request(send_url !== null && send_url !== void 0 ? send_url : location.href, {
                method: "POST",
                body: fd,
            });
            const response = yield fetch(request);
            if (response.ok) {
                return response.text();
            }
            else {
                throw new Error("HTTPコード " + response.status + " サーバーとの通信に失敗しました");
            }
        }))();
    }
    /**
     * 配列からformデータを作り,指定されたメソッドでサーバーへ送る
     */
    post(params, send_url = null) {
        const fd = new FormData();
        Object.entries(params).forEach(([key, value]) => {
            fd.append(key, String(value !== null && value !== void 0 ? value : ''));
        });
        return this.send(fd, send_url);
    }
    /**
     * GETリクエストでページを取得しDOM書き換え
     */
    get(params, send_url = null, target_id = null) {
        const url = new URL(send_url !== null && send_url !== void 0 ? send_url : window.location.href);
        Object.entries(params).forEach(([key, value]) => {
            url.searchParams.delete(key);
            url.searchParams.append(key, value);
        });
        history.replaceState(null, '', url.href);
        const promise = (() => __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(url.href);
            if (response.ok) {
                return response.text();
            }
            else {
                throw new Error("HTTPコード " + response.status + " サーバーとの通信に失敗しました");
            }
        }))();
        this.rewriteElems(promise, target_id);
    }
    /**
     * 要素を書き換え
     * 第二引数で書き換える対象を指定する 指定がない場合はBodyを書き換える
     */
    rewriteElems(promise, target_id = null) {
        promise
            .then((htmlText) => {
            const parser = new DOMParser();
            return parser.parseFromString(htmlText, "text/html");
        })
            .then((html) => {
            var _a, _b, _c, _d, _e, _f;
            if (target_id) {
                const target_elem = html.getElementById(target_id);
                if (target_elem) {
                    (_a = document.getElementById(target_id)) === null || _a === void 0 ? void 0 : _a.replaceWith(target_elem);
                    // サーバーから返ったHTMLにerrors,alertsがある場合はその要素を挿入
                    const errorsElem = html.getElementById("errors");
                    const alertsElem = html.getElementById("alerts");
                    if (errorsElem) {
                        (_b = document.getElementById("bread_crumbs")) === null || _b === void 0 ? void 0 : _b.insertAdjacentElement("afterend", errorsElem);
                    }
                    else if (alertsElem) {
                        (_c = document.getElementById("bread_crumbs")) === null || _c === void 0 ? void 0 : _c.insertAdjacentElement("afterend", alertsElem);
                    }
                    // 返ってきたHTMLにトークンが含まれているなら、全てのトークンを書き換える
                    const tokensFromServer = (_e = (_d = html.querySelector("[data-token]")) === null || _d === void 0 ? void 0 : _d.dataset.token) !== null && _e !== void 0 ? _e : (_f = html.querySelector("[name*='_token']")) === null || _f === void 0 ? void 0 : _f.value;
                    if (tokensFromServer) {
                        document.querySelectorAll("[data-token]").forEach((el) => {
                            el.dataset.token = tokensFromServer;
                        });
                        document.querySelectorAll("[name*='_token']").forEach((el) => {
                            el.value = tokensFromServer;
                        });
                    }
                }
            }
            else {
                // 指定がない場合はBody要素を書き換え
                if (html.body) {
                    document.body.replaceWith(html.body);
                }
            }
            // DOM書き換え後にマークダウン変換とツールチップを再初期化
            md.mdParse();
            common.helpMsg.initial();
        })
            .catch((error) => {
            console.error(error);
        });
    }
}
window.ajax = new FetchOperation();
